module.exports = __webpack_public_path__ + "img/Jump Casting16.7e25a70b.jpg";